module.exports = __webpack_public_path__ + "h5/img/timeBg.3d61fc84.png";